<template>
  <footer class="fast-footer">
    <!-- TODO: Hardcode showing map over footer -->
    <!-- <client-only>
      <div
        v-if="isHomePage && contact.fullAddress"
        class="fast-embeded fast-embeded--full tw-overflow-hidden tw-h-[300px] tw-w-full"
      >
        <iframe
          :src="`https://maps.google.com/maps?q=${encodeURIComponent(contact.fullAddress)}&output=embed`"
          width="100%"
          height="100%"
          frameborder="0"
          style="border: 0"
          allowfullscreen
          loading="lazy"
          referrerpolicy="no-referrer-when-downgrade"
        />
      </div>
    </client-only> -->
    <!-- Footer Main Section -->
    <div
      class="fast-footer-main tw-container md:tw-py-14 tw-pt-11 tw-pb-[25px]"
    >
      <div
        class="fast-footer-widgets tw-grid tw-grid-cols-1 sm:tw-grid-cols-2 lg:tw-grid-cols-3 lg:tw-gap-20 tw-gap-[25px]"
      >
        <!-- About Section -->
        <FooterAbout />

        <!-- Widget Links -->
        <div class="lg:tw-col-start-2">
          <FooterWidgetLink />
        </div>

        <!-- Contact Section -->
        <FooterContact />
      </div>
    </div>

    <!-- Footer Bottom Section -->
    <div
      class="fast-footer-copyright tw-container tw-px-4 lg:tw-px-0 lg:tw-border-t-[0.5px] tw-border-t-light-gray-2 md:tw-py-4 tw-pt-4 tw-pb-4 md:tw-pb-4"
    >
      <div>
        <div
          class="tw-flex tw-flex-col md:tw-flex-row md:tw-justify-between tw-items-center tw-gap-6"
        >
          <!-- Copyright Text -->
          <div
            class="tw-text-center md:tw-text-left tw-order-2 md:tw-order-1 tw-border-t-[0.5px] tw-border-t-light-gray-2 lg:tw-border-t-0 tw-py-4 sm:tw-py-0"
          >
            <span class="tw-text-dt-body-small">
              Copyright © 2020 {{ websiteName }}. All Rights Reserved. Powered
              by
              <a
                :href="platformUrl"
                :title="platformName"
                target="_blank"
                class="link-underline-hover"
              >
                {{ platformName }}
              </a>
            </span>
          </div>

          <!-- Social Contact for Desktop -->
          <div class="tw-order-1 md:tw-order-2">
            <FooterSocialContact />
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script setup lang="ts">
const route = useRoute();
const contact = useContactStore();
const websiteInfoStore = useWebsiteInfoStore();
const websiteName = computed(() => websiteInfoStore?.name || "Your Website");
const isHomePage = computed(() => route.path === "/");
const { platformUrl, platformName } = useBrand();
</script>

<style scoped>
.fast-footer {
  @apply tw-mb-[68px] md:tw-mb-0;
}

.fast-footer-widgets {
  @apply tw-space-y-6 lg:tw-space-y-0;
}

/* @media (min-width: 1024px) {
  :deep(.web-description) {
    font-size: var(--theme-font-text-dt-body-small-size);
    line-height: var(--theme-font-text-dt-body-small-line-height);
    font-weight: var(--theme-font-text-dt-body-small-weight);
  }
} */
</style>
